module.exports = __webpack_public_path__ + "img/nba-oe-playbook.8bbb8099.jpg";